<template>
	<v-container fluid class="ma-0 pa-0 pl-12">
		<v-col class="ma-0 pa-0" cols="12" id="head_title">
			<v-col class="pa-0" cols="12" id="main_content">
				<v-row class="ma-0 pa-0" align="center" id="header_height">
					<router-link :to="{ path: '/setting' }"
						style="color:transparent;">
						<v-col class="ma-0 pa-0" cols="auto" align="center"
							style="color:#08B0FF;font-size:1rem;text-align:center;">
							{{ts('title')}}
						</v-col>
					</router-link>
					<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
						src="@/assets/images/history_arrow.png"></v-img>
          <router-link :to="{ path: '/setting/authority' }"
						style="color:transparent;">
						<v-col class="ma-0 pa-0" cols="auto" align="center"
							style="color:#08B0FF;font-size:1rem;text-align:center;">
							{{ts('shareUserPermissionSettings')}}
						</v-col>
					</router-link>
					<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
						src="@/assets/images/history_arrow.png"></v-img>
					<v-col class="ma-0 pa-0" cols="auto">
						{{this.detailTitle}}
					</v-col>
				</v-row>
			</v-col>
		</v-col>
    <v-col class="pa-0" id="main_content" cols="12" align="center">
			<v-col class="ma-0 pa-0 pt-9 mb-15" cols="10" align="left">
				<v-row class="ma-0 pa-0" align="center" justify="start">
          <v-btn width="auto" height="2rem" id="choose_file"
            class="light_blue_btn ma-0 pa-0 pl-2 pr-2" elevation="0" @click="chooseFile()">
            {{ts('chooseFile')}}
          </v-btn>
          <input type="file" ref="fileInput" accept=".csv" @change="onFileChange" style="display: none;">
          <v-col class="ma-0 pa-0 pl-2" cols="auto">
            {{fileName}}
          </v-col>
        </v-row>
        <v-row v-if="!isRegistering" class="ma-0 pa-0 mt-2" align="center" justify="start">
          <v-btn width="auto" height="2rem" id="btn_register"
            :disabled="!fileLoaded || hasErrors"
            @click="handleRegister"
            :style="{
              'background-color': !fileLoaded || hasErrors ? '#84d5fc !important' : '#008dd0', // 배경색 조절
              'color': !fileLoaded || hasErrors ? 'white !important' : 'white' // 글자색 조절
            }"
          >
          {{ts('register')}}
          </v-btn>
        </v-row >
        <v-row v-else class="ma-0 pa-0 mt-2" align="center">
          {{ ts('registering') }}
        </v-row>
        <v-row class="ma-0 pa-0 mt-2">
          <!-- 스크롤이 힘들어 class에서 custom-scrollbar를 없앰 -->
          <v-data-table
            :headers="headers"
            :items="formattedRecords"
            class="elevation-1"
            dark>
            <template v-slot:item="{ item }">
              <tr :class="{ 'notchangeable-row' : item.result === 'ー', 'highlight-row' : item.result === 'X' }">
                <!-- headers 배열을 사용하여 동적으로 td 생성 -->
                <td v-for="header in headers" :key="header.value">
                  <v-row align="center" no-gutters>
                    <v-col class="d-flex align-center">
                      <v-tooltip v-if="item.error[header.value]" bottom color=rgba(148,148,148,1.0)>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" color="red" small>mdi-alert</v-icon>
                        </template>
                        <v-row class="ma-0">
                          <v-col class="pa-0 text-center">
                            <v-icon color="red">mdi-alert</v-icon>
                            <span style="color: red; font-size:medium">入力エラーが発生しました！</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0">
                          <v-col class="mt-1 pa-0 text-left">
                            <span style="color: black;" v-html="item.error[header.value]"></span>
                          </v-col>
                        </v-row>
                      </v-tooltip>
                      <span :style="{ color: item.error[header.value] ? 'red' : '' }">
                        {{ item[header.value] }}
                      </span>
                    </v-col>
                  </v-row>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-row>
			</v-col>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import Papa from 'papaparse';
import { BatchType } from '@/constants';
import { keyMap, keyMapPrivate } from '@/views/setting/authority/csvProcessor';
import { toLower } from 'lodash';

export default {
  props: ['type'],
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
    detailTitle: '',
    fileName: '',
    fileLoaded: false,
    isRegistering: false,
    records: [],
    headers: [],
    role: ''
	}),
  created() {
    this.role = this.roleCheck(this.$store.getters.getRole);
  },
  mounted() {
    this.handleType();
  },
  computed: {
    formattedRecords() {
      // Create a reverse map of keyMapPrivate for easy lookup
      const reverseKeyMap = new Map();
      keyMap.forEach((value, key) => {
        reverseKeyMap.set(value, key);
      });
      const reverseKeyMapPrivate = new Map();
      keyMapPrivate.forEach((value, key) => {
        reverseKeyMapPrivate.set(value, key);
      });
      
      return this.records.map(record => {
        let formattedRecord = { ...record };
        formattedRecord.error = {};
        // FE ValidCheck
        Object.keys(formattedRecord).forEach(key => {
          if (toLower(formattedRecord[key]) === 'true') {
            formattedRecord[key] = 'true'; // 일관된 소문자로 변환
          } else if (toLower(formattedRecord[key]) === 'false') {
            formattedRecord[key] = 'false'; // 일관된 소문자로 변환
          }
          // key가 keyMap이나 keyMapPrivate에 있는지 확인 
          if (reverseKeyMap.has(key) || reverseKeyMapPrivate.has(key)) {
            if (!this.validateBoolean(formattedRecord[key])) {
              formattedRecord.error[key] = 
              `・不正な文字列が使用されている可能性があります。<br>
              ・この権限を利用可能にする場合は、trueを指定してください。<br>
              ・この権限を利用制限する場合は、 falseを指定してください。`;
            }
          } else if (key === 'メールアドレス') {
            if (!this.validateEmail(formattedRecord[key])) {
              formattedRecord.error[key] = '・メールアドレスの形式が正しくありません。';
            }
          } else if (key === 'COMMAND') {
            if (!this.validateCommand(formattedRecord[key])) {
              formattedRecord.error[key] = '・コマンドが正しいことを確認してください。';
            }
          }
        });
        if (this.type === BatchType.USER_GROUP) {
          if (formattedRecord['権限グループ名'] == '') {
            formattedRecord.error['権限グループ名'] = '・権限グループ名は空の値にすることはできません。';
          }
        }
        // BE ErrorCode
        if (formattedRecord.errorCodes) {
          if (formattedRecord.errorCodes.includes(1001)) {
            formattedRecord.error['UMID'] = '・UMIDが存在しないか、変更権限がありません。';
          }
          if (formattedRecord.errorCodes.includes(1002)) {
            formattedRecord.error['名前'] = '・名前は変更できません。';
          }
          if (formattedRecord.errorCodes.includes(1003)) {
            formattedRecord.error['ユーザーID'] = '・ユーザーIDは変更できません。';
          }
          if (formattedRecord.errorCodes.includes(1004)) {
            formattedRecord.error['メールアドレス'] = '・メールアドレスは変更できません。';
          }
          if (formattedRecord.errorCodes.includes(1101)) {
            formattedRecord.error['権限グループID'] = '・存在しない権限グループID。';
          }
          if (formattedRecord.errorCodes.includes(1102)) {
            formattedRecord.error['権限グループ名'] = '・権限グループ名は変更できません。';
          }
          if (formattedRecord.errorCodes.includes(1103)) {
            formattedRecord.error['権限グループID'] = '・変更権限がない権限グループID。';
          }
          if (formattedRecord.errorCodes.includes(1104)) {
            formattedRecord.error['権限グループID'] = '・削除権限がない権限グループID。';
          }
          if (formattedRecord.errorCodes.includes(1201)) {
            formattedRecord.error['ID'] = '・存在しないID。';
          } 
          if (formattedRecord.errorCodes.includes(1202)) {
            formattedRecord.error['ID'] = '・削除権限がないID。';
          } 
        }
        return formattedRecord;
      });
    },
    hasErrors() {
      return this.formattedRecords.some(record => Object.keys(record.error).length > 0);
    }
  },
	methods: {
		ts(t) {
      return this.$t("lang.settings." + t);
    },
    validateBoolean(value) {
      return toLower(value) === 'true' || toLower(value) === 'false';
    },
    validateEmail(email) {
      const trimmedEmail = email.trim();
      const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(String(trimmedEmail).toLowerCase());
    },
    validateCommand(value) {
      return toLower(value) === 'delete' || toLower(value) === '';
    },
    handleType() {
      if (this.type === BatchType.USER_AUTHORITY) {
        this.detailTitle = this.ts('userPermissionImport');
      } else if (this.type === BatchType.USER_GROUP) {
        this.detailTitle = this.ts('privilegeGroupImport')
      } else if (this.type === BatchType.STORE_GROUP) {
        this.detailTitle = this.ts('storeGroupImport')
      }
    },
    chooseFile() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.fileName = file.name;
        this.readFile(file);
      }
    },
    readFile(file) {
      const reader = new FileReader();
      reader.onload = e => {
        const buffer = e.target.result;
        let encoding = 'shift-jis';

        try {
          // Attempt to decode as UTF-8
          new TextDecoder('utf-8', { fatal: true }).decode(buffer);
          encoding = 'utf-8';
        } catch (e) {
          // If decoding as UTF-8 fails, fall back to shift-jis
          encoding = 'shift-jis';
        }

        const decoder = new TextDecoder(encoding);
        const text = decoder.decode(buffer);

        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            this.fileLoaded = true;
            this.updateHeaders(results.meta.fields);
            this.records = results.data.map((record, index) => ({
              ...record,
              id: index + 1,
              result: ''
            }));
          },
          error: (error) => {
            console.error('파일 읽기 오류:', error);
          }
        });
      };
      reader.onerror = e => {
        console.error('파일 읽기 오류:', reader.error);
      };
      reader.readAsArrayBuffer(file);
    },
    updateHeaders(fields) {
      this.headers = [
        { text: this.ts('number'), value: 'id'},  // 일련번호 헤더
        { text: this.ts('result'), value: 'result'},  // 결과 헤더
        ...fields.map(field => ({ text: field, value: field }))
      ];
    },
    async registerRecords() {
      this.isRegistering = true;
      for (let index = 0; index < this.records.length; index++) {
        let record = this.records[index];
        let result = 'O';
        let errorCodes = [];
        let params = null;
        let res = '';
        // 각 레코드를 서버에 등록하고 그 결과를 저장
        // TODO: 결과 실패시 사유를 저장해야 함.
        try {
          if (this.type === BatchType.USER_AUTHORITY) {
            params = this.buildUserAuthParams(record);
            if (params.userGroupAuthGroupId === '') {
              res = await this.networkController.postBatchAccountAuthGroup(params);
              errorCodes.push(...res.data.errorCodes)
              result = res.data.errorCodes.length == 0 ? 'O' : 'X';
            } else {
              result = 'ー';
            }
            // 사용자 권한 등록
          } else if (this.type === BatchType.USER_GROUP) {
            params = this.buildUserGroupParams(record);
            if (toLower(record['COMMAND']) === 'delete') {
              res = await this.networkController.deleteBatchUserGroupAuthGroup({'id': params.id});
            } else if(params.id === '') {
              res = await this.networkController.postBatchUserGroupAuthGroup(params);
            } else {
              res = await this.networkController.patchBatchUserGroupAuthGroup(params);
            }
            // 사용자 그룹 등록
          } else if (this.type === BatchType.STORE_GROUP) {
            params = this.buildStoreGroupParams(record);
            let reqMap = {};
            if (toLower(record['COMMAND']) === 'delete') {
              reqMap.deleteId = params.id;
              res = await this.networkController.deleteBatchSharedUserStoreGroup(reqMap);
            } else {
              result = 'ー';
            }
            // 점포 그룹 등록
          }
          this.$set(this.records, index, { ...record, result, errorCodes });
        } catch (error) {
          console.error('Error in registerRecords:', error);
          errorCodes.push(error.response.data.status);
          this.$set(this.records, index, { ...record, result: 'X', errorCodes }); // 예: 실패를 표시하기 위해 'X'로 설정
        }
      }
    },
    async handleRegister() {
      try {
        await this.registerRecords();
      } finally {
        this.isRegistering = false;

        // 결과 확인 및 다이얼로그 표시
        if (this.records.every(record => record.result != 'X')) {
          this.$dialog.confirm({
            text: this.ts('registerCompleted'),
            actions: {
              true: {
                color: 'white',
                text: this.t('confirm'),
                handle: () => {
                  this.$router.push({ path: '/setting/authority' });
                }
              }
            }
          });
        } else {
          this.$dialog.confirm({
            text: this.ts('registerCompleted') + '<br>' + this.ts('error'),
            actions: {
              true: {
                color: 'white',
                text: this.t('confirm')
              }
            }
          });
        }
      }
    },
    // formatResult(result) {
    //   // 서버 결과에 따른 문자열 또는 아이콘 반환
    //   return result ? 'O' : 'X';  // 결과에 따라 체크 또는 삼각형 표시 ✔️⚠️
    // },
    getKeyMap() {
      return this.role === 'main' || this.role === 'head' ? keyMap : keyMapPrivate;
    },
    buildUserAuthParams(record) {
      const newRecord = { authGroup: {} };
      const reversedKeyMap = new Map(Array.from(this.getKeyMap(), a => [a[1], a[0]]));
      // reverseKeyMap에 추가 key-value 쌍을 추가해준다
      const additionalMappings = new Map([
        //['権限', 'accountRole'],
        ['名前', 'name'],
        ['ユーザーID', 'userName'],
        ['メールアドレス', 'mailAddress'],
        ['権限グループ名', 'userGroupAuthGroupName'],
        ['権限グループID', 'userGroupAuthGroupId'],
        ['UMID', 'umid'],
      ]);

      Object.entries(record).forEach(([key, value]) => {
        if (reversedKeyMap.has(key)) {
          const permissionField = reversedKeyMap.get(key);
          newRecord.authGroup[permissionField] = value;
          // newRecord.authGroup[reversedKeyMap.get(key)] = value;
        } else if (additionalMappings.has(key)) {
          newRecord[additionalMappings.get(key)] = value;
        }
      });

      return newRecord;
    },
    buildUserGroupParams(record) {
      const newRecord = { authGroup: {} };
      const reversedKeyMap = new Map(Array.from(this.getKeyMap(), a => [a[1], a[0]]));
      // reverseKeyMap에 추가 key-value 쌍을 추가해준다
      const additionalMappings = new Map([
        ['権限グループ名', 'name'],
        ['権限グループID', 'id'],
      ]);

      Object.entries(record).forEach(([key, value]) => {
        if (reversedKeyMap.has(key)) {
          const permissionField = reversedKeyMap.get(key);
          // Map the key and assign it to the authGroup object
          newRecord.authGroup[permissionField] = value;
        } else if (additionalMappings.has(key)) {
          // Keep other keys at the root level of the newRecord
          newRecord[additionalMappings.get(key)] = value;
        }
      });

      return newRecord;
    },
    buildStoreGroupParams(record) {
      const newRecord = {};
      const reversedKeyMap = new Map(Array.from(this.getKeyMap(), a => [a[1], a[0]]));
      // reverseKeyMap에 추가 key-value 쌍을 추가해준다
      const additionalMappings = new Map([
        ['ユーザID', 'userName'],
        ['店舗グループ名', 'name'],
        ['メールアドレス', 'mailAddress'],
        ['ID', 'id'],
        ['UMID', 'umid'],
        ['店舗グループID', 'storeGroupId'],
      ]);

      Object.entries(record).forEach(([key, value]) => {
        if (additionalMappings.has(key)) {
          newRecord[additionalMappings.get(key)] = value;
        }
      });

      return newRecord;
    }
	}
}
</script>

<style lang="scss" scoped>
#header_text {
  font-size: 1.5rem;
  text-align: left;
}
#header_divider {
	border: 1px solid rgb(141, 141, 141);
}
.light_blue_btn {
	background-color: #89aeff;
	color: #008DD0;
	border-radius: 4px;
	min-width: 1rem;
	border: 1px solid #008DD0;
}
#btn_register {
  border-radius: 4px;
  color: white;
  width: auto;
  height: 2rem;
}
.error-row {
  color: red;
}
.custom-scrollbar ::-webkit-scrollbar {
  height: 3px;
}
.custom-scrollbar ::-webkit-scrollbar-thumb {
  background-color: white;
}
.custom-scrollbar ::-webkit-scrollbar-track {
  background-color: #4A4A4A;
}

::v-deep .v-data-table__wrapper tbody tr {
  background-color: inherit !important; /* 기본 배경 색상 유지 */
}
::v-deep .v-data-table__wrapper tbody tr.highlight-row:hover {
  background-color: inherit !important; /* 마우스 오버 시 배경색 변하지 않게 */
}

::v-deep .highlight-row {
  color: red !important; /* 텍스트 색상 빨간색으로 변경 */
}
::v-deep .notchangeable-row {
  color: gray !important;
}
</style>
